module.exports = __webpack_public_path__ + "img/vgtrk.60f828bc.svg";